<template>
  <v-dialog
  v-if="visiblePopup"
  content-class="invite-users-popup"
  :value="visiblePopup"
  :max-width="372"
  scrollable
  @click:outside="onCloseClick"
  @keydown.esc="onCloseClick"
  >
  <v-card class="popup-wrapper" >
      <div class="content">
        <div class="invite-title">
          {{ $t('invite.users.popup.title') }}
        </div>
        <div class="send-invitations-form">
            <div class="emails-inputs" v-for="(value, index) in emails" :key="index">
              <div class="text-field-section">
                  <text-field
                      :rules="rules"
                      type="text"
                      v-model="emails[index].email"
                      class="login"
                      :label="$t('send.invite.popup.row.label') + ' #' + (index+1)"
                      :placeholder="$t('send.invite.popup.textfield.label')"
                  />
              </div>
              <div class='delete-row-section'>
                <custom-tooltip popper-class="light-tooltip" placement="right">
                  <div slot='buttonContent'>
                <span
                  class="delete-icon material-icons"
                  :title="$t('delete')"
                  @click="deleteCurrentEmail(index)"
                >
                      highlight_off
                  </span>
                  </div>
                  <div slot="content">
                    <slot name="tooltip">
                      {{$t('delete')}}
                    </slot>
                  </div>
                </custom-tooltip>
              </div>
          </div>
          <div class="add-new-email-section">
            <div class="add-new-email-header">
                <label  class="add-new-email-add-button"  @click="addEmail">
                    <span class="plus">+</span>{{ $t('add.new.email.popup.button') }}
                </label>
            </div>
          </div>
        </div>
      </div>
      <span v-if='alreadySigned'>
        <v-alert
          text
          dense
          color="#e0255e"
          icon="info"
          border="left"
          class='not-valid-message'
        >
          {{ $t('registration.client.info.signed.emails') }}
        </v-alert>
      </span>
      <span v-if='isDuplicate'>
          <v-alert
            text
            dense
            color="#e0255e"
            icon="info"
            border="left"
            class='not-valid-message'
          >
            {{ $t('registration.client.info.duplicate.emails') }}
          </v-alert>
      </span>
      <div class="buttons">
        <v-btn small depressed class="cancel-button btn-secondary" @click="onCloseClick"> {{ $t('confirm.cancel') }} </v-btn>
        <v-btn small depressed :disabled="saveButtonDisabled" class="save-button btn-primary" @click="onSaveClick">
          {{ $t('send.invite.button') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { rules } from '@/utils/validationUtils';
import TextField from '@/components/common/TextField.vue';
import CustomTooltip from '@/components/common/CustomTooltip.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

/* eslint-disable */
export default {
  name: 'SendInvitationPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: {
    TextField,
    CustomTooltip,
  },
  props: {
    visiblePopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      index: 0,
      emails: [{email:''}],
      isFormValid: false,
      isDuplicate: false,
      alreadySigned: false,
    }
  },
  watch: {
    emails: {
      handler() {
        const validEmailsArray = [];
        const signedUserEmails = this.tenantUsers.map(user => user.email);
        const rules = [this.emailRules.email, this.emailRules.emailSubdomain];
        for (let i = 0; i < this.emails.length; i += 1) {
          if (this.emails[i]) {
            const validationForCurrentRef = rules?.map(validationRule => {
              let result = false;
              this.alreadySigned = false;
              if (this.emails[i].email !== '') {
                result = validationRule(this.emails[i].email);
              }
              return result;
            });
            const booleanValue = validationForCurrentRef.every(e => ((typeof (e) === 'boolean') && (e === true)));
            validEmailsArray.push(booleanValue);
            if (signedUserEmails.includes(this.emails[i].email)) {
              this.alreadySigned = true;
            }
          }
        }
        const emailStrings = this.emails.map(item => item.email);
        const uniqueList = emailStrings.every((email, index) => emailStrings.indexOf(email) === index);
        this.isDuplicate = !uniqueList;
        this.isFormValid = !validEmailsArray.includes(false) && uniqueList && !this.alreadySigned;
      },
      deep: true,
    },
  },
  computed:{
    ...mapGetters(['domains', 'tenantUsers']),
    saveButtonDisabled() {
      return !this.isFormValid;
    },
    emailRules(){
      return {
        ... rules,
        email: v => rules.email(v) || this.$t('registration.client.info.email.is.not.valid'),
        emailSubdomain: v => rules.emailSubdomain(v) || this.$t('registration.client.info.email.is.not.valid'),
        subdomain: v => rules.subdomain(v) || this.$t('registration.client.info.email.is.not.valid')
      }
    },
    rules() {
      return [this.emailRules.email, this.emailRules.emailSubdomain];
    },
  },
  methods: {
    addEmail() {
        this.emails.push({ email:'' });
    },
    deleteCurrentEmail(index) {
      if (this.emails.length > 1) {
        this.emails.splice(index, 1);
      } else {
        this.emails = [
          {
            id: this.emails[index].id,
            email: '',
          },
        ];
      }
    },
    onCloseClick() {
      this.emails = [{email:''}];
      this.index = 0;
      this.$emit('closeInvitePopup');
    },
    sendInvitaions() {
      let formattedEmails = [{email:''}];
      this.emails.forEach(email => {
        if(email.email !== '') {
          formattedEmails.push(email);
        }
      });
      this.emails = formattedEmails;
    },
    onSaveClick() {
      this.$emit('saveInvite', this.emails);
      this.emails = [{email:''}];
      this.index = 0;    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.send-invitations-form {
 .emails-inputs {
    display: flex;
    align-items: center;
    margin-bottom: $space-5;
    .text-field-section{
        flex:0 0 rem(292);
    }
    .delete-row-section{
      flex:1;
      display: flex;
      align-items: center;
    }
    .delete-icon {
      color: var(--severity-critical);
      cursor: pointer;
      font-size: rem(16);
      margin-left: $space-2;
      font-weight: bolder;
    }

    .dummy-icon {
      width: rem(16);
      height: rem(16);
    }
  }
  .add-new-email-section {
    padding: 0;

    .add-new-email-header {
      display: flex;
      justify-content: space-between;

      .add-new-email-add-button {
        color: #4d9feb;
        text-transform: uppercase;
        font-size: $font-size-sm;
        font-weight: 500;
        letter-spacing: 1.07px;
        line-height: rem(16);
        text-align: center;
        margin-right: $space-3;
        cursor: pointer;

        .plus {
          font-size: rem(16);
        }
      }
    }
  }
  .duplicate-email-message {
    color: var(--severity-critical);
    font-size: $font-size-sm;
    margin-bottom: rem(-25);
    margin-top: rem(3);
  }
}
.invite-users-popup {
  .popup-wrapper {
    max-width: rem(372);
    padding: $space-8 $space-10;
    height: 100%;

    .content {
      .invite-title {
        text-transform: uppercase;
        color: var(--text-primary);
        font-size: $font-size-base;
        font-weight: 600;
        letter-spacing: 1.12px;
        line-height: rem(16);
        margin-bottom: $space-4;
      }
      padding-bottom: $space-5;
    }

    .buttons {
      text-align: right;

      .cancel-button {
        height: $btn-height-md;
        border-radius: $radius-sm;
      }

      .save-button {
        height: $btn-height-md;
        border-radius: $radius-sm;
        margin-left: $space-2;
      }
    }
  }
  .not-valid-message {
    font-size: $font-size-xs;
    font-weight: 600;
    letter-spacing: 1.12px;
    line-height: rem(16);
  }
}
</style>
<style lang="scss">
@import '~@/assets/styles/design-system';

.v-dialog__content--active{
  .invite-users-popup{
    overflow-y: auto;
  }
}
</style>
